import { Link as BaseLink } from '@exam-management/router';
import { Button, DescriptionOutlinedIcon } from '@shared/components';
import type { ComponentProps } from 'react';

type BaseLinkProps = ComponentProps<typeof BaseLink>;

interface GoToParagraphLinkProps {
  to: BaseLinkProps['to'];
  params?: BaseLinkProps['params'];
}

export default function GoToParagraphLink(props: Readonly<GoToParagraphLinkProps>) {
  const { to, params } = props;

  return (
    // @ts-expect-error MUI's loading button does not support `component` prop
    <Button
      variant='outlined'
      color='secondary'
      size='small'
      startIcon={<DescriptionOutlinedIcon />}
      component={BaseLink}
      to={to}
      params={params}
    >
      Go to Paragraph
    </Button>
  );
}
